<template>
    <v-dialog v-model="value" :max-width="width" persistent no-click-animation class="FciDialog" @click:outside="close">
        <v-card style="border-radius: 0">
            <v-layout align-center class="primary px-2 py-1">
                <div class="title" style="color: #fff">{{ title }}</div>
                <v-spacer></v-spacer>
                <v-btn small icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-layout>
            <slot></slot>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'FciDialog',
    props: {
        title: String,
        value: Boolean,
        width: {
            type: Number,
            default: 700
        }
    },
    methods: {
        close () {
            this.$emit('input', false)
        }
    }
}
</script>

<style scoped lang="scss">

</style>
